import "./styles/App.css";
import MainApp from "./features/MainApp";

function App() {
    return <MainApp />
}

export default App;